import { useStore } from 'vuex';

function toCamelCase(string) {
  return string
    .toLowerCase()
    .replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''));
}

/**
 * Provides easy access to the profile's role permissions
 *
 * Usage:
 * ```
 * const { paymentsEdit, formsAdmin } = useRolePermissions();
 * if (paymentsEdit) { ... }
 * ```
 *
 * @returns {Object} An object containing camel case properties for all permissions
 */
export default function useRolePermissions(store = useStore()) {
  const rolePermissions = store?.state?.profile?.role_permissions || {};
  const rolePermissionsObject = {};

  Object.keys(rolePermissions).forEach((key) => {
    const camelCaseKey = toCamelCase(key);
    rolePermissionsObject[camelCaseKey] = !!rolePermissions[key];
  });

  // Create a Proxy to dynamically handle any permission access
  const permissionsProxy = new Proxy(rolePermissionsObject, {
    get(target, prop) {
      if (prop === 'rolePermissions') return rolePermissions;
      if (prop in target) return target[prop];

      // Return false for non-Specialists
      return false;
    },
  });

  return permissionsProxy;
}
